import { gql } from "@apollo/client";

export const CREATE_JOB_DAY = gql`
  mutation createJobDay(
    $date: Date!
    $startTime: Time!
    $endTime: Time
    $driver: ID
    $truck: ID
    $driver2: ID
    $truck2: ID
    $driver3: ID
    $truck3: ID
    $scopeOfWork: String
    $job: ID!
    $crewAssignments: [Int]
    $vehicleOption: String
  ) {
    createJobDay(
      date: $date
      startTime: $startTime
      endTime: $endTime
      driver: $driver
      truck: $truck
      driver2: $driver2
      truck2: $truck2
      driver3: $driver3
      truck3: $truck3
      scopeOfWork: $scopeOfWork
      job: $job
      crewAssignments: $crewAssignments
      vehicleOption: $vehicleOption
    ) {
      jobDay {
        id
      }
    }
  }
`;

export const EDIT_JOB_DAY = gql`
  mutation editJobDay(
    $id: Int!
    $date: Date!
    $startTime: Time!
    $endTime: Time
    $scopeOfWork: String
    $driver: ID
    $truck: ID
    $driver2: ID
    $truck2: ID
    $driver3: ID
    $truck3: ID
    $crewAssignmentsToAdd: [Int]
    $crewAssignmentsToDelete: [Int]
    $vehicleOption: String
  ) {
    editJobDay(
      id: $id
      date: $date
      startTime: $startTime
      endTime: $endTime
      scopeOfWork: $scopeOfWork
      driver: $driver
      truck: $truck
      driver2: $driver2
      truck2: $truck2
      driver3: $driver3
      truck3: $truck3
      crewAssignmentsToAdd: $crewAssignmentsToAdd
      crewAssignmentsToDelete: $crewAssignmentsToDelete
      vehicleOption: $vehicleOption
    ) {
      jobDay {
        id
      }
    }
  }
`;

export const DELETE_JOB_DAY = gql`
  mutation deleteJobDay($id: Int!) {
    deleteJobDay(id: $id) {
      didDelete
    }
  }
`;
